/**
 * 图片url转成图片File
 * @param url
 * @returns
 */
export const urlToFile = (url: string): Promise<Blob> => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = '';
        image.src = url;
        image.onload = function (): void {
            //转base64
            const base64ImageSrc = getBase64Image(image);
            //base64转file
            const file = dataURLtoFile(base64ImageSrc);
            resolve(file);
        };
        image.onerror = (e): void => reject(e);
    });
};

/**
 * 图片转成base64
 * @param img
 * @returns
 */
export function getBase64Image(img: HTMLImageElement): string {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    ctx.drawImage(img, 0, 0, img.width, img.height);
    const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
    const dataURL = canvas.toDataURL('image/' + ext);
    return dataURL;
}

/**
 * base64转成文件
 * @param dataUrl
 * @returns
 */
export function dataURLtoFile(dataUrl: string): Blob {
    //去掉url的头，并转换为byte
    const bytes = window.atob(dataUrl.split(',')[1]);
    //处理异常,将ascii码小于0的转换为大于0
    const ab = new ArrayBuffer(bytes.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpg' });
}



